// Mobile hamburger
document.querySelector(".hamburger").addEventListener("click", function () {
	this.classList.toggle("active");

	const mobileMenu = document.querySelector(".mobile-menu");
	const body = document.body;

	if (this.classList.contains("active")) {
		mobileMenu.classList.add("active");
		body.classList.add("no-scroll");
	} else {
		mobileMenu.classList.remove("active");
		body.classList.remove("no-scroll");
	}
});

// Mobile child toggle
const toggleButtons = document.querySelectorAll(".js-toggle-child");

toggleButtons.forEach((button) => {
	button.addEventListener("click", function (e) {
		e.preventDefault();

		const parentLi = this.closest("li");

		if (parentLi) {
			parentLi.classList.toggle("active");
		}
	});
});

// Product slider
const swiperEl = document.querySelector(".product-swiper");
if (swiperEl) {
	const swiper = new Swiper(swiperEl, {
		direction: "horizontal",
		loop: true,
		spaceBetween: 8,
		slidesPerView: 2,
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 16,
			},
		},
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
	});
}

// Gallery slider
const swiperGa = document.querySelector(".gallery-swiper");
if (swiperGa) {
	const swiperGallery = new Swiper(swiperGa, {
		direction: "horizontal",
		loop: true,
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
	});

	document.querySelectorAll('.js-swipe-to').forEach(el => {
		el.addEventListener('click', () => {
			const slideIndex = parseInt(el.id.replace('swipe-slide-', '')) - 1;

			swiperGallery.slideTo(slideIndex, 0);
			document.querySelector('.popup-gallery').classList.add('active');
		});
	});
}

// Toggle gallery
document.querySelectorAll('.js-toggle-gallery').forEach(function(el) {
	el.addEventListener('click', function(e) {
		e.preventDefault();
		const gallery = document.querySelector('.popup-gallery');
		gallery.classList.toggle('active');

		if (gallery.classList.contains('active')) {
			document.body.classList.add('no-scroll');
		} else {
			document.body.classList.remove('no-scroll');
		}
	});
});

// Add active class to forms if input is on focus or has value
const gformInputs = document.querySelectorAll(
    '.js-gform input[type=text], .js-gform input[type=tel], .js-gform input[type=email], .js-gform input[type=number], .js-gform textarea'
);

gformInputs.forEach(input => {
    if (input.value.length) {
        input.closest('.gfield').classList.add('active');
    }

    input.addEventListener('focus', () => {
        input.closest('.gfield').classList.add('active');
    });

    input.addEventListener('blur', () => {
        if (!input.value.length || input.value.includes('_')) {
            input.closest('.gfield').classList.remove('active');
        }
    });
});

document.querySelectorAll('.js-gform select').forEach(select => {
    select.addEventListener('change', () => {
        select.closest('.gfield').classList.toggle('active', select.value !== '');
    });
});

// Home Hero + Video Text video play/pause
(function () {
	function updateIcons(btn, isPlaying) {
		var pauseIcon = btn.querySelector(".icon-pause");
		var playIcon = btn.querySelector(".icon-play");
		var playIconMobile = btn.querySelector(".icon-play-mobile");
		var isDesktop = window.matchMedia("(min-width: 991px)").matches;

		if (pauseIcon) pauseIcon.style.display = isPlaying ? "" : "none";

		if (playIcon)
			playIcon.style.display = !isPlaying && isDesktop ? "" : "none";
		if (playIconMobile)
			playIconMobile.style.display =
				!isPlaying && !isDesktop ? "" : "none";
	}

	document.addEventListener("click", function (e) {
		var btn = e.target.closest(
			".block-home-hero .play-pause, .block-video-text .play-pause",
		);
		if (!btn) return;

		var block = btn.closest(".block-home-hero, .block-video-text");
		if (!block) return;

		var iframeVideo =
			block.querySelector("#homeHeroBgVideo") ||
			block.querySelector("iframe[data-provider]");

		var mp4Video =
			block.querySelector("#homeHeroBgVideoMp4") ||
			block.querySelector('video[data-provider="mp4"]');

		var isPlaying = btn.classList.contains("is-playing");

		// MP4 video
		if (mp4Video) {
			if (isPlaying) mp4Video.pause();
			else mp4Video.play();

			btn.classList.toggle("is-playing");
			updateIcons(btn, !isPlaying);
			return;
		}

		// Iframe video (YouTube / Vimeo / Wistia)
		if (!iframeVideo || !iframeVideo.contentWindow) return;

		var provider = iframeVideo.getAttribute("data-provider");
		if (!provider) return;

		// Youtube
		if (provider === "youtube") {
			iframeVideo.contentWindow.postMessage(
				JSON.stringify({
					event: "command",
					func: (isPlaying ? "pause" : "play") + "Video",
					args: [],
				}),
				"*",
			);
		} else {
			// Vimeo + Wistia
			iframeVideo.contentWindow.postMessage(
				{ method: isPlaying ? "pause" : "play" },
				"*",
			);
		}

		btn.classList.toggle("is-playing");
		updateIcons(btn, !isPlaying);
	});
})();

// Icon Slider Slick Init
(function ($) {
	function handleIconSlider() {
		var isMobile = window.matchMedia("(max-width: 991px)").matches;

		$(".block-icon-slider .icon-slides").each(function () {
			var $slider = $(this);
			var isInit = $slider.hasClass("slick-initialized");

			if (isMobile) {
				if (isInit) return;

				var $arrows = $slider.next(".slick-arrows");

				$slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					infinite: true,
					centerMode: true,
					centerPadding: "25px",
					appendArrows: $arrows.length ? $arrows : $slider,
					prevArrow: `
			  <button type="button" class="slick-prev" aria-label="Previous">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
				  <rect x="-0.5" y="0.5" width="31" height="31" rx="15.5" transform="matrix(-1 0 0 1 31 0)" stroke="#D6C6AF"/>
				  <path d="M17.6754 9.32977C17.4822 9.14524 17.178 9.14524 16.9848 9.32977L10.3787 15.6384C10.1724 15.8354 10.1724 16.1646 10.3787 16.3616L16.9848 22.6702C17.178 22.8548 17.4822 22.8548 17.6754 22.6702L18.6213 21.7669C18.8276 21.5699 18.8276 21.2406 18.6213 21.0437L13.7185 16.3616C13.5122 16.1646 13.5122 15.8354 13.7185 15.6384L18.6213 10.9563C18.8276 10.7594 18.8276 10.4301 18.6213 10.2331L17.6754 9.32977Z" fill="#232628"/>
				</svg>
			  </button>
			`,
					nextArrow: `
			  <button type="button" class="slick-next" aria-label="Next">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
				  <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#D6C6AF"/>
				  <path d="M14.3246 9.32977C14.5178 9.14524 14.822 9.14524 15.0152 9.32977L21.6213 15.6384C21.8276 15.8354 21.8276 16.1646 21.6213 16.3616L15.0152 22.6702C14.822 22.8548 14.5178 22.8548 14.3246 22.6702L13.3787 21.7669C13.1724 21.5699 13.1724 21.2406 13.3787 21.0437L18.2815 16.3616C18.4878 16.1646 18.4878 15.8354 18.2815 15.6384L13.3787 10.9563C13.1724 10.7594 13.1724 10.4301 13.3787 10.2331L14.3246 9.32977Z" fill="#232628"/>
				</svg>
			  </button>
			`,
				});
			} else if (isInit) {
				$slider.slick("unslick");
			}
		});
	}

	$(handleIconSlider);
	$(window).on("resize", handleIconSlider);
})(jQuery);

// Accordion Toggle
(function () {
	document.addEventListener("click", function (e) {
		var trigger = e.target.closest(".block-accordion .heading-row");
		if (!trigger) return;

		var item = trigger.closest(".accordion-item");
		if (!item) return;

		item.classList.toggle("is-open");
	});

	document.querySelectorAll(".block-accordion").forEach(function (block) {
		var first = block.querySelector(".accordion-item");
		if (first && !block.querySelector(".accordion-item.is-open")) {
			first.classList.add("is-open");
		}
	});
})();

jQuery(document).on('change', '#gform_3 input[type="radio"][name="input_11"]', function() {
	jQuery('#gform_next_button_3_10').click();
});

jQuery(document).on('change', '#gform_4 input[type="radio"][name="input_11"]', function() {
	jQuery('#gform_next_button_4_10').click();
});

jQuery(document).on('change', '#gform_5 input[type="radio"][name="input_8"]', function() {
	jQuery('#gform_next_button_5_6').click();
});

jQuery(document).on('change', '#gform_6 input[type="radio"][name="input_18"]', function() {
	jQuery('#gform_next_button_6_20').click();
});